import React, { useEffect, useState, Fragment } from 'react'

import axios from 'axios'
import $ from 'jquery'
import * as Papa from 'papaparse'

import ShopMoreProducts from '../ShopMoreProducts/ShopMoreProducts'
import Loader from '../Loader/Loader'

import './ShopMore.scss'

import { getShuffledArray, getUniqueListBy, slugString } from '../../helpers/helpers'

const BOOST_LIVE_URL =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&sort=best-selling&product_available=true&q='

const MATCH_URL =
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vR1hFrohwOxDA0-NxXXtySjuXIzhFl_5ZL-eyDfeDYEKboySbGirqGTVXSNSlRMsAn4-bz-V0OJk2e-/pub?output=csv'

const ShopMore = ({ queryType, shopMoreTitle, mainProduct }) => {
    // console.log('mainProduct', mainProduct)
    // console.log('query', query)
    const [isDev, setIsDev] = useState(false)
    const [queryTerm, setQueryTerm] = useState('')
    const [backfill, setBackfill] = useState([])
    const [products, setProducts] = useState([])
    const [currentColor, setCurrentColor] = useState('')
    // const [productId, setProductId] = useState('')
    // const [isPrint, setIsPrint] = useState(true)
    const [totalProductsAvalible, setTotalProductsAvalible] = useState(null)
    const [noProducts, setNoProducts] = useState(false)

    let shopTitle = shopMoreTitle
    shopTitle = shopTitle.replace(/['"]+/g, '')

    useEffect(() => {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            setIsDev(true)
        } else {
            setIsDev(false)
        }
    }, [])

    useEffect(() => {
        if (queryType === 'print') {
            // console.log('queryTerm', queryTerm)
            // console.log('useEffect print2', queryTerm)

            const fetchData = async () => {
                const cc = $('.current-color-text-text').text()
                setCurrentColor(cc)
                let queryString = slugString(cc)
                queryString = cc.replace(/\s+/g, '%20')

                console.log('queryString', queryString)
                setQueryTerm(queryString)

                let queryUrl = BOOST_LIVE_URL + queryString
                const data = await axios(queryUrl)

                // console.log('print data from axios', data, queryUrl)

                const products = data.data.products
                let matchingProducts = []

                products.filter((p) => {
                    if (p.available && p.id !== mainProduct[0].id) {
                        p.variants.map((v) => {
                            if (v.initial_color === currentColor) {
                                matchingProducts.push(p)
                            }
                            return null
                        })
                    }
                    return null
                })

                matchingProducts = [...new Set(matchingProducts)]

                matchingProducts = matchingProducts.filter((p) => {
                    // console.log('mainProduct', mainProduct, p)
                    return p.handle.indexOf(mainProduct[0].handle) === -1 && p.title.indexOf('hidden') === -1
                })

                let shuffledProducts = getShuffledArray(matchingProducts)

                shuffledProducts = shuffledProducts.slice(0, 5)

                const shuffledLength = shuffledProducts.length

                shuffledProducts = [...new Set(shuffledProducts)]

                matchingProducts = matchingProducts.slice(0, 5)
                setProducts(matchingProducts)
                setTotalProductsAvalible(shuffledLength)
            }

            // setProducts([])
            fetchData()

            if (queryTerm && queryTerm.length) {
            }
        }
        /* eslint-disable-next-line */
    }, [queryType, queryTerm])

    useEffect(() => {
        if (queryType === 'product') {
            setProducts([])
            let productType

            if (mainProduct && mainProduct[0]) {
                productType = mainProduct[0].product_type
            } else {
                productType = 'One-Pieces'
            }

            // update

            ;(async () => {
                await Papa.parse(MATCH_URL, {
                    download: true,
                    header: true,
                    complete: function (data) {
                        // console.log('match data', data)
                        data.data.map((d) => {
                            if (d.product_type.indexOf(productType) > -1) {
                                // console.log('match', d)

                                let queryPair = d.pair
                                    ? d.pair.replace(/\s+/g, '%20')
                                    : productType
                                if (queryPair && queryPair.length > 0) {
                                    queryPair = slugString(queryPair)
                                    setQueryTerm(queryPair)
                                } else {
                                    setQueryTerm(productType)
                                }

                                // console.log(
                                //     'queryTerm in product type, queryPair',
                                //     queryTerm,
                                //     queryPair
                                // )

                                const fetchData = async () => {
                                    let queryUrl = BOOST_LIVE_URL + queryPair

                                    // console.log('queryUrl', queryUrl)
                                    const data = await axios(queryUrl)

                                    const products = data.data.products

                                    // console.log('products', products)

                                    let matchingProducts = []

                                    products.filter((p) => {
                                        if (
                                            p.id !== mainProduct[0].id &&
                                            p.available
                                        ) {
                                            matchingProducts.push(p)
                                        }
                                        return null
                                    })

                                    matchingProducts.map((p) => {
                                        return {
                                            ...p,
                                            title: p.title.split('_')[0],
                                            handle: p.handle.split('_')[0],
                                        }
                                    })

                                    // console.log(
                                    //     'matchingProducts',
                                    //     matchingProducts
                                    // )

                                    matchingProducts = [
                                        ...new Set(matchingProducts),
                                    ]

                                    matchingProducts = getUniqueListBy(
                                        matchingProducts,
                                        'title'
                                    )

                                    // console.log(
                                    //     'matchingProducts after set + unique',
                                    //     matchingProducts
                                    // )

                                    let shuffledProducts =
                                        getShuffledArray(matchingProducts)

                                    shuffledProducts = shuffledProducts.slice(
                                        0,
                                        5
                                    )

                                    const shuffledLength =
                                        shuffledProducts.length

                                    if (shuffledLength < 5) {
                                        let fill = backfill.slice(0, 10)
                                        let backfilled = [
                                            ...shuffledProducts,
                                            fill,
                                        ]
                                        backfilled = backfilled.flat(1)
                                        backfilled = getUniqueListBy(
                                            backfilled,
                                            'id'
                                        )
                                        backfilled = backfilled.slice(0, 5)

                                        setProducts(backfilled)
                                    } else {
                                        shuffledProducts = [
                                            ...new Set(shuffledProducts),
                                        ]

                                        setProducts(shuffledProducts)
                                    }

                                    // Set session function
                                    let myDate = new Date()

                                    let expiredAt = myDate.setHours(
                                        myDate.getHours() + 1
                                    )

                                    // console.log('expiredAt', expiredAt)

                                    let obj = {
                                        products: shuffledProducts,
                                        expiredAt: expiredAt,
                                    }
                                    sessionStorage.setItem(
                                        'sessionObj',
                                        JSON.stringify(obj)
                                    )
                                }

                                if (queryPair && queryPair.length) {
                                    setProducts([])
                                    fetchData()
                                }
                            }
                            return null
                        })
                    },
                })
            })()
        }
    }, [backfill, queryType, queryTerm, mainProduct])

    useEffect(() => {
        $(document).on('click', '.swatch-item', function () {
            setProducts([])

            let currentColor = $(this).data('swatch-color')

            let queryUpdate = ''
            if (currentColor) {
                queryUpdate = currentColor.replace(/\s+/g, '%20')
                queryUpdate = currentColor.replace(/\//g, '%20')
            } else {
                queryUpdate = queryTerm
            }

            // console.log('queryUpdate after click', queryUpdate)

            setCurrentColor(currentColor)
            setQueryTerm(queryUpdate)
        })
        /* eslint-disable-next-line */
    }, [])

    useEffect(() => {
        if (queryType === 'print' && products.length === 0) {
            setTimeout(() => {
                setNoProducts(true)
            }, 5000)
        }
    }, [products, queryType])

    return (
        <Fragment>
            <div className="shop-more-outer">
                <div className="shop-more-inner">
                    <div className="shop-more-header">
                        {queryType === 'print' &&
                        totalProductsAvalible !== null &&
                        totalProductsAvalible <= 0 ? null : (
                            <h2>
                                {shopTitle}{' '}
                                {queryType.indexOf('print') > -1
                                    ? `in ${currentColor}`
                                    : null}
                            </h2>
                        )}
                    </div>
                    {products && products.length > 0 && (
                        <ShopMoreProducts
                            products={products}
                            mainProduct={mainProduct}
                            queryTerm={queryTerm}
                            queryType={queryType && queryType}
                        />
                    )}
                    {products.length === 0 && !noProducts ? (
                        <Loader />
                    ) : (
                        queryType === 'print' &&
                        products.length === 0 &&
                        !noProducts && (
                            <div className="no-products">
                                Sorry, no matching products found.
                            </div>
                        )
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default ShopMore
